export const logo = {
  src: require("../../images/logo.png"),
};

export const logo2 = {
    src: require("../../images/logo2.png"),
  };
  